import { TableProps } from "./types";
import "./styles.scss";

export const Table = ({ data }: TableProps) => {
  const { thead, tbody } = data;
  return (
    <>
      <table
        data-testid="table"
        className="table">
        <thead>
          <tr>
            {thead.map((th, index) => (
              <th key={index}>{th.item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tbody.map(({ tr }, index) => (
            <tr key={index}>
              {tr.map(({ item }, index) => (
                <td key={index}>{item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};
